<template>
  <el-card class="card-main">
    <div class="left">
      <div v-for="(item, index) in projectDeviceList" :key="index" class="parent" @click="changeProject(index)">
        <div class="header">
          <div class="title">
            <span>{{ item.projectName || '--' }}</span>
            <i class="el-icon-arrow-up" v-if="activeName === index"></i>
            <i class="el-icon-arrow-down" v-else></i>
          </div>
          <div class="inline">
            <p><span class="dot"></span><span class="tit">离线</span> <span class="cou">{{ item.offDeviceNum || 0 }}</span>
            </p>
            <p><span class="dot1"></span><span class="tit">在线</span> <span class="cou">{{ item.onDeviceNum || 0 }}</span>
            </p>
          </div>
        </div>
        <div class="child_div" v-show="activeName === index">
          <div v-for="(item1, index1) in item.devices" :class="{ 'active': active === index1 }" :key="index1"
            class="child" @click.stop="choose(item1, index1)">
            <div class="header">
              <span>{{ item1.deviceName }}</span>
              <span class="tag" :class="{ offline: item1.deviceStatus === '2' }">{{ item1.deviceStatus === '1' ? '在线' :
                '离线'}}</span>
            </div>
            <div class="content">设备串号：{{ item1.deviceNumber }}</div>
          </div>
        </div>
      </div>
    </div>
    <div id="map"></div>
    <div class="drawer" :class="drawer ? 'drawerShow' : 'drawerHide'">
      <template v-if="drawerData">
        <div class="info">
          <p class="title">割草机器人</p>
          <p class="text">设备名称<span>{{ drawerData.deviceName || '--' }}</span></p>
          <p class="text">设备串号<span>{{ drawerData.deviceNumber || '--' }}</span></p>
          <p class="text">设备状态
            <span class="highlight" :class="drawerData.deviceStatus === '2' ? 'gray' : ''">
              {{ drawerData.deviceStatus === '1' ? '在线' : '离线' }}
            </span>
          </p>
        </div>
        <div class="line paramList">
          <div class="paramItem">
            <p class="ttl ttl-long">预设割草面积</p>
            <p v-if="drawerData.mowingArea"><span class="large">{{ drawerData.mowingArea }}</span>㎡</p>
            <p v-else>--</p>
          </div>
          <div class="paramItems">
            <p class="ttl ttl-long">任务信息</p>
            <el-table :data="taskInfoData" class="global-table global-tables" border>
              <el-table-column label="工作日" show-overflow-tooltip prop="week" width="100"></el-table-column>
              <el-table-column label="工作时间段" show-overflow-tooltip>
                <template v-slot="{ row }">
                  <span>{{ row.time1Start }} - {{ row.time1End }}</span>
                  <span class="timeDis">{{ row.time2Start ? row.time2Start + ' - ' : '' }}{{ row.time2End }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="paramItem" v-if="cuttp === '1'">
            <p class="ttl ttl-long">周期性工作</p>
            <p>开</p>
          </div>
          <div class="paramItem" v-if="cuttp === '1'">
            <p class="ttl ttl-long">间隔割草时间</p>
            <p>{{ cuttpNum }}天</p>
          </div>
          <div class="paramItem">
            <p class="ttl ttl-long">下次割草时间</p>
            <p>{{ drawerData.mowingTime || '--' }}</p>
          </div>
        </div>
        <div class="line paramList">
          <div class="paramItem">
            <p class="ttl">运行状态</p>
            <p v-if="['1', '2', '3'].includes(drawerData.runState) && drawerData.deviceStatus === '1'"
              class="c-block yellow">
              {{ drawerData.runState === '1' ? '待机' : drawerData.runState === '2' ? '回仓' : drawerData.runState === '3' ?
              '休眠等待' :
              ''}}
            </p>
            <p v-else-if="drawerData.runState === '0' && drawerData.deviceStatus === '1'" class="c-block green">割草</p>
            <p v-else-if="drawerData.runState === '4' && drawerData.deviceStatus === '1'" class="c-block blue">充电</p>
            <p v-else>--</p>
          </div>
          <div class="paramItem">
            <p class="ttl">当前电量</p>
            <template
              v-if="(!drawerData.quantityElectricity && drawerData.quantityElectricity !== '0') || drawerData.deviceStatus === '2'">
              <p>--</p>
            </template>
            <template v-else>
              <el-progress :percentage="Number(drawerData.quantityElectricity)" :color="electricityProgressColor"
                :show-text="false" :stroke-width="8"></el-progress>
              <p v-if="drawerData.quantityElectricity < 20" class="c-red">{{ drawerData.quantityElectricity }}%</p>
              <p v-else-if="drawerData.quantityElectricity < 80" class="c-yellow">{{ drawerData.quantityElectricity }}%
              </p>
              <p v-else class="c-green">{{ drawerData.quantityElectricity }}%</p>
            </template>
          </div>
          <template v-if="drawerData.runState === '0' && drawerData.deviceStatus === '1'">
            <div class="paramItem">
              <p class="ttl">割草进度</p>
              <p>{{ drawerData.mowingProgress || drawerData.mowingProgress === '0' ? drawerData.mowingProgress + '%' :
                '--'}}</p>
            </div>
            <div class="paramItem">
              <p class="ttl">割草时长</p>
              <p>{{ drawerData.mowingLong || '--' }}</p>
            </div>
            <div class="paramItem">
              <p class="ttl">本次剩余</p>
              <p>{{ drawerData.restTime || '--' }}</p>
            </div>
            <div class="paramItem">
              <p class="ttl">完工剩余</p>
              <p>{{ drawerData.completionSurplus || '--' }}</p>
            </div>
          </template>
          <template v-else-if="drawerData.runState === '4' && drawerData.deviceStatus === '1'">
            <div class="paramItem">
              <p class="ttl">充电电流</p>
              <p>{{ drawerData.chargingCurrent ? drawerData.chargingCurrent + 'A' : '--' }}</p>
            </div>
            <div class="paramItem">
              <p class="ttl">已充时长</p>
              <p>{{ drawerData.fullTime || '--' }}</p>
            </div>
            <div class="paramItem">
              <p class="ttl">充满剩余</p>
              <p>{{ drawerData.chargeRemaining || '--' }}</p>
            </div>
          </template>
        </div>
        <div v-if="drawerData.faultInformation" class="line paramList">
          <div class="title paramError">
            <img src="@/assets/icon/sumec/error.svg" />
            <p>故障</p>
          </div>
          <div class="paramItem">
            <p class="ttl">故障信息</p>
            <p class="c-danger">{{ drawerData.faultInformation }}</p>
          </div>
        </div>
        <div class="line">
          <el-button type="primary" v-show="$ButtonShow('MIC_EDT_04')"
            @click="onDetail(drawerData.deviceNumber, 'ControlBoard')" class="btnControl">控制台</el-button>
          <el-button type="primary" @click="onDetail(drawerData.deviceNumber, 'DeviceInfo')">查看</el-button>
        </div>
      </template>
    </div>
  </el-card>
</template>

<script>
import { drawPolygon } from '@/utils/formatData'
export default {
  name: 'DetailMap',
  data() {
    return {
      drawer: false,
      map: null,
      ploygons: [],
      markers: [],
      onlineImg: require('@/assets/icon/sumec/normal.svg'),
      onlineImgCursor: require('@/assets/icon/sumec/normal-big.svg'),
      offImg: require('@/assets/icon/sumec/offline.svg'),
      offImgCursor: require('@/assets/icon/sumec/offline-big.svg'),
      warningImg: require('@/assets/icon/sumec/warning.svg'),
      warningImgCursor: require('@/assets/icon/sumec/warning-big.svg'),
      baseImg: require('@/assets/icon/sumec/base.svg'),
      deviceList: [],
      drawerData: null,
      taskInfoData: [],
      cuttp: '',
      cuttpNum: '',
      projectDeviceList: [],
      projectId: '',
      active: -1,
      projectLocation: [],
      activeName: 0
    }
  },
  computed: {
    electricityProgressColor() {
      let color = ''
      if (this.drawerData && (this.drawerData.quantityElectricity || this.drawerData.quantityElectricity === '0')) {
        color = Number(this.drawerData.quantityElectricity) < 20
          ? '#FF603B' : Number(this.drawerData.quantityElectricity) < 80
            ? '#FFC117' : '#13C2C2'
      }
      return color
    }
  },
  created() {
    // this.getPloygon()
    this.getData()
  },
  mounted() {
  },
  destroyed() {
    if (this.markers) {
      this.markers.forEach((item) => {
        item.off('click', this.drawerOpen)
      })
    }
    if (this.ploygons) {
      this.ploygons.forEach(item => {
        item.off('click', this.drawerClose)
      })
    }
    if (this.map) {
      this.map.off('click', this.drawerClose)
      this.map.clearMap()
    }
  },
  methods: {
    // 左侧项目列表
    getData() {
      this.$axios.get(this.$apis.moving.selectProjectMowingByList).then(res => {
        this.projectDeviceList = res || []
        if (this.projectDeviceList.length > 0) {
          this.projectId = this.projectDeviceList[0].projectId
          this.getPloygon()
        } else {
          this.$nextTick(() => {
            this.initMap(116.4017, 39.9)
          })
        }
      })
    },
    getPloygon() {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.projectId
      }).then((res) => {
        if (res) {
          this.projectLocation = res.locationList || []
          const lng = Number(res.longitude)
          const lat = Number(res.latitude)
          this.$nextTick(() => {
            this.initMap(lng, lat)
          })
        } else {
          this.$message.error('未获取到项目信息')
        }
      })
    },
    // 初始化地图
    initMap(lng, lat) {
      const center = [lng, lat]
      const map = new AMap.Map('map', {
        center: center,
        zoom: 11
      })
      this.map = map
      this.ploygons = drawPolygon(this.map, this.projectLocation || [], null, this.drawerClose)
      this.getDeviceList()


      // 点击地图关闭抽屉
      this.map.on('click', this.drawerClose)
    },

    // 获取设备信息
    getDeviceList() {
      this.$axios.get(this.$apis.moving.selectJgMowingInfoMapByList, {
        projectId: this.projectId
      }).then((res) => {
        this.projectDeviceList[this.activeName].devices = res
        this.drawMarker(res)
        this.$forceUpdate()
      })
    },

    choose(row, index) {
      this.active = index
      if (this.map) {
        const e = {
          target: {}
        }
        if (row.longitude && row.latitude) {
          e.target = this.markers.find((item) => {
            return item.detail.deviceNumber === row.deviceNumber
          })
          this.map.setCenter([Number(row.longitude), Number(row.latitude)])
        } else {
          this.iconTab()
          e.target = {
            detail: row
          }
        }
        this.drawerOpen(e)
      }
    },

    // 切换项目
    changeProject(index) {
      this.active = -1
      const id = this.projectDeviceList[index].projectId
      if (this.projectId !== id) {
        this.projectId = id
        this.activeName = index
        this.getPloygon()
        this.drawerClose()
      } else {
        this.activeName = -1
        this.projectId = ''
      }
    },

    // 获取图片
    getIcon(deviceStatus, faultInformation, isCurrent) {
      if (!isCurrent) {
        return (deviceStatus === '1' ? (faultInformation === '1' ? this.warningImg : this.onlineImg) : this.offImg)
      } else {
        return (deviceStatus === '1' ? (faultInformation === '1' ? this.warningImgCursor : this.onlineImgCursor) : this.offImgCursor)
      }
    },

    // 地图打点
    drawMarker(list) {
      this.markers = []
      if (list && list.length) {
        // 循坏将设备marker添加到地图
        list.forEach((item) => {
          const areaList = item.jgMovingMaps.map((areaItem) => {
            return {
              fenceCode: areaItem.fenceCode || '',
              longitude: Number(areaItem.longitude),
              latitude: Number(areaItem.latitude),
              mapName: areaItem.mapName || ''
            }
          })
          drawPolygon((this.map), areaList, {
            fillColor: 'rgb(69, 182, 172)', // 背景色
            fillOpacity: 0.7, // 背景透明
            strokeWeight: 2, // 线条宽度
            strokeColor: 'rgba(69, 182, 172, 1)', // 线条色
            strokeStyle: 'dashed', // 线条轮廓线样式
            clickable: false // 是否可点击
          })
          // 基站添加
          if (item.chargeLongitude && item.chargeLatitude) {
            const markerBase = new AMap.Marker({
              icon: new AMap.Icon({
                // 图标的取图地址
                image: this.baseImg
              }),
              offset: new AMap.Pixel(-19, -18),
              position: new AMap.LngLat(Number(item.chargeLongitude), Number(item.chargeLatitude)),
              extData: item
            })
            markerBase.detail = item
            markerBase.on('click', this.drawerOpen)
            this.map && this.map.add(markerBase)
          }
          // 割草机器人添加
          if (item.longitude && item.latitude) {
            const icon = this.getIcon(item.deviceStatus, item.faultInformation, false)
            const marker = new AMap.Marker({
              icon: new AMap.Icon({
                // 图标的取图地址
                image: icon
              }),
              offset: new AMap.Pixel(-18, -48),
              position: new AMap.LngLat(Number(item.longitude), Number(item.latitude)),
              extData: { ...item, type: 'icon' }
            })
            marker.detail = item
            marker.on('click', this.drawerOpen)
            this.map && this.map.add(marker)
            this.markers.push(marker)
          }
        })
      }
    },

    // 抽屉打开
    drawerOpen(e) {
      console.log(e, 'e');
      console.log(e.target.getExtData(), 'e.target.getExtData()');

      const info = e.target.getExtData()
      if (this.drawerData === null || (this.drawerData && this.drawerData.deviceNumber !== info.deviceNumber)) {
        if (this.drawerData && this.drawerData.deviceNumber !== info.deviceNumber) {
          this.drawerClose()
        }
        this.drawerData = info
        // 获取设备详情数据
        this.getDeviceDetail()
        // 点击切换大图标
        const iconClick = this.getIcon(info.deviceStatus, info.faultInformation, true)
        // 获取对应的割草机器人
        if (info.type !== 'icon') {
          const index = (this.map).getAllOverlays('marker').findIndex((item) => item.getExtData() && item.getExtData().deviceNumber === info.deviceNumber && item.getExtData().type === 'icon')
          if (index >= 0) {
            const marker = (this.map).getAllOverlays('marker')[index]
            marker.setOffset(new AMap.Pixel(-22, -64))
            marker.setIcon(iconClick)
          }
        } else {
          e.target.setOffset(new AMap.Pixel(-22, -64))
          e.target.setIcon(iconClick)
        }
      }
      this.drawer = true
    },

    // 处理机器人详情数据
    getDeviceDetail() {
      const weekData = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      if (this.drawerData) {
        this.taskInfoData = this.drawerData.cuttimeList
        this.cuttp = this.drawerData.cuttp
        this.cuttpNum = this.drawerData.cuttpNum
        for (let i = this.taskInfoData.length - 1; i >= 0; i--) {
          this.taskInfoData[i].week = weekData[i]
          if (this.taskInfoData[i].time2Start === '00:00' && this.taskInfoData[i].time2End === '00:00') {
            this.taskInfoData[i].time2Start = ''
            this.taskInfoData[i].time2End = ''
          }
          if (this.taskInfoData[i].isWork === '2') {
            this.taskInfoData.splice(i, 1)
          }
        }
      }
    },

    // 抽屉关闭
    drawerClose() {
      if (this.drawer) {
        this.drawer = false
        // 清空抽屉
        this.iconTab()
        this.drawerData = null
      }
    },

    // 替换图标
    iconTab() {
      if (this.map && this.drawerData) {
        const deviceNumber = this.drawerData.deviceNumber || ''
        const index = this.markers.findIndex((item) => item.detail.deviceNumber === deviceNumber)
        const icon = this.getIcon(this.drawerData.deviceStatus, this.drawerData.faultInformation, false)
        const marker = this.markers[index]
        if (this.drawerData.longitude && this.drawerData.latitude) {
          marker.setOffset(new AMap.Pixel(-18, -48))
          marker.setIcon(icon)
        }
      }
    },

    onDetail(id, state) {
      // 设备详情
      this.$router.push({
        name: 'mowLawnDetail',
        params: { projectId: this.projectId, deviceNumber: id },
        query: {
          state
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/color.scss';

.el-card {
  height: 100%;
}

::v-deep .el-card__body {
  position: relative;
  height: 100%;
  display: flex;
}

.left {
  width: 342px;
  height: 100%;
  background: #F6F7FB;
  border-radius: 2px;
  margin-right: 16px;
  padding: 6px;
  overflow: auto;

  .parent {
    width: 290px;
    margin-bottom: 10px;

    .header {
      height: 60px;
      background: #FFFFFF;
      padding: 8px 10px 8px;
      color: #000;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      cursor: pointer;

      .title {
        display: flex;
        justify-content: space-between;
      }

      .inline {
        display: flex;

        p {
          margin-right: 30px;
        }
      }

      .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #9B9B9B;
        border-radius: 2px;
        margin-right: 4px;
      }

      .dot1 {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #7ED321;
        border-radius: 2px;
        margin-right: 4px;
      }
    }

    .tit {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
    }

    .cou {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
    }
  }

  .child_div {
    width: 278px;
    margin-top: 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;

    .child {
      width: 100%;
      height: 88px;
      background: #FFFFFF;
      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;

      &.active {
        border: 2px solid #1ad1b0;

        .header {
          background: rgba(26, 209, 176, .1) !important;
        }
      }

      .header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 44px;
        background: #F6F7FB;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        text-align: left;
        padding: 11px 16px;
      }

      .tag {
        width: 44px;
        height: 20px;
        background: #1AD1B0;
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.offline {
          background: #999999;
        }
      }

      .content {
        padding: 11px 16px;
      }
    }
  }
}

.container {
  width: 100%;
  height: 100%;
  background: #FFFFFF;

  .online {
    width: 270px;
    height: 200px;
    position: absolute;
    left: 40px;
    top: 90px;
    background-color: #fff;
    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    z-index: 10;

    &>div {
      width: 100%;
      height: 100%;
    }
  }

  #map {
    width: calc(100% - 200px);
    height: 100%;
  }

  ::v-deep .amap-marker-label {
    border: 1px solid #fff;
  }
}

.drawer {
  position: absolute;
  right: -420px;
  top: 100px;
  z-index: 20;
  width: 380px;
  height: calc(100% - 145px);
  padding: 16px;
  background: #FFFFFF;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  border-left: 4px solid $color-default;
  transition: all 0.4s;
  overflow: auto;

  .title {
    font-size: 16px;
    color: $color-font-dark;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .info {
    padding-bottom: 20px;

    .text {
      font-size: 14px;
      color: $color-font-dark;
      font-weight: 500;
      line-height: 30px;
      position: relative;

      span {
        margin-left: 10px;
        color: $color-font-default;
      }

      .highlight {
        display: inline-block;
        position: absolute;
        text-align: center;
        width: 44px;
        top: -50%;
        margin-top: 20px;
        background: $color-default;
        border-radius: 2px;
        color: #fff;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
      }

      .gray {
        background: #B7B7B7;
      }
    }
  }

  .line {
    border-top: 1px solid #F1F1F1;
    padding-top: 20px;
  }

  .paramList {
    margin-bottom: 20px;

    .paramItem {
      display: flex;
      margin-bottom: 10px;

      p {
        font-size: 14px;
        line-height: 24px;
        color: #333;

        &.ttl {
          width: 66px;
          color: #000;

          &.ttl-long {
            width: 94px;
          }
        }

        .large {
          font-family: 'DINAlternateBold';
          font-size: 24px;
          color: #52C41A;
          vertical-align: baseline;
          padding-right: 5px;
        }

        &.c-block {
          width: auto;
          height: 20px;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 18px;
          border-radius: 2px;
          padding: 0px 8px;
        }

        &.c-block.yellow {
          background: #FFC117;
        }

        &.c-block.green {
          background: #45B6AC;
        }

        &.c-block.blue {
          background: #1EA2FF;
        }

        &.c-red {
          color: #FF603B;
        }

        &.c-yellow {
          color: #FFC117;
        }

        &.c-green {
          color: #13C2C2;
        }

        &.c-danger {
          color: #FE3A2F;
        }
      }

      .el-progress {
        width: 160px;
        height: 8px;
        margin: 8px 5px 0 0;

        ::v-deep {

          .el-progress-bar__outer,
          .el-progress-bar__inner {
            border-radius: 1px;
          }
        }
      }

      .el-link {
        font-size: 12px;
        height: 20px;
        margin-left: 10px;
        border-bottom: 1px solid #1AD1B0;
      }
    }

    .paramItems {
      margin-bottom: 10px;

      p {
        font-size: 14px;
        line-height: 24px;
        color: #333;

        &.ttl {
          width: 66px;
          color: #000;

          &.ttl-long {
            width: 94px;
          }
        }
      }

      .timeDis {
        margin-left: 16px
      }
    }

    .paramError {
      display: flex;

      img {
        margin-right: 4px;
      }
    }
  }
}

.drawerShow {
  transform: translateX(-460px)
}

.drawerHide {
  transform: translateX(0px)
}

.btnControl {
  background-color: #2C8EFF;
  border-color: #2C8EFF;
}

::v-deep .amap-info-close {
  display: none;
}

::v-deep .amap-marker-label {
  .marker-label-content {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }

  &::after {
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-5px);
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    /* 三角形左边透明 */
    border-right: 5px solid transparent;
    /* 三角形右边透明 */
    border-top: 5px solid #FFFFFF;
    /* 三角形顶部为黑色，可以根据需要修改颜色 */
  }
}
</style>
